<template>
  <v-card-title class="heading-offset-wrapper mx-7">
    <div class="bg-white">
      <v-card
        :flat="isSelector ? true : false"
        :elevation="isSelector ? 0 : ''"
        :color="isSelector ? 'white' : 'primary'"
        :class="innerStyle"
      >
        <v-card-title>
          <v-layout row wrap>
            <v-flex class="xs12 sm12 md12 lg12 px-3">
              <h2
                :class="
                  isSelector
                    ? `black--text ${titleClass}`
                    : `white--text ${titleClass}`
                "
                v-if="title"
                v-text="title"
              ></h2>
              <p
                v-if="subtitle"
                class="font-weight-regular subtitle-2 mb-2"
                :class="isSelector ? 'black--text' : 'white--text'"
                v-text="subtitle"
              ></p>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
    </div>
  </v-card-title>
</template>

<script>
export default {
  props: {
    title: {},
    titleClass: {},
    subtitle: {},
    isSelector: {
      default: false
    }
  },

  computed: {
    innerStyle() {
      if (this.subtitle) {
        return 'elevation-8 offset-heading rounded heading-offset-40'
      } else {
        return 'elevation-8 offset-heading rounded heading-offset-30'
      }
    }
  }
}
</script>

<style scoped>
.offset-heading {
  position: absolute !important;
  width: 100%;
  top: -90px;
  left: 0;
}

.heading-offset-wrapper {
  position: relative;
  margin-top: 60px;
}

.heading-offset-30 {
  position: relative;
  top: -31px;
}

.heading-offset-40 {
  position: relative;
  top: -42px;
}
</style>
